export default __webpack_public_path__ + "static/br1-85436d347be00a6c22ca921b401fc49a.png";